// src/constants/constants.ts
import "@fortawesome/fontawesome-free/css/all.min.css";
import { Email } from "@mui/icons-material";
import {  common, green, yellow } from "@mui/material/colors";
import { getCognitoGroups } from "./jwtUtils";

export const selectedSettings = {
        size: 30,
        fontModification: 'bold',
    };

export const colorMap = {
  shapeColor: {FunktionarPerson :"#C795F3", // Darker Neon Purple
              Address: "#18a46cff", // Darker Neon Orange
              Company: {
                default: '#2980b9', // Darker Neon Blue
                withDebt: '#c0392b', // Darker Red
                withBankrupcy: '#c0392b',
                withLikvidation: '#f39c12', // Darker Yellow
                highRiskBoard: '#c0392b',
                starting: '#27ae60', // Darker Green
                ending: '#27ae60',
                highRiskRelationship: '#ecf0f1',
                activeRelationship: '#ecf0f1',
                oldRelationship: '#ecf0f1',
                indicatorMoreRelationships: '#ecf0f1',
                isOnWatchlist: '#f39c12'
              },
  PhoneNumber: "#16a085" // Darker Teal
},
  iconColor: {FunktionarPerson: common.white,
              Address: common.white,
          Company: {
            default: common.white,
            withDebt: common.white,
            withBankrupcy: common.white,
            withLikvidation: common.white,
            highRiskBoard: common.white,
            starting: common.white,
            ending: common.white,
            highRiskRelationship: common.black,
            activeRelationship: common.black,
            oldRelationship: common.black,
            indicatorMoreRelationships: common.black,
            isOnWatchlist: common.white,
          },
  PhoneNumber:  common.white
        }
};

export const iconMap = {
  FunktionarPerson: {
    code: "\uf007", // Unicode for user
    size: 20,
    color: colorMap.iconColor.FunktionarPerson, // the color of the icon
    description: "Board member",
    shapeColor: colorMap.shapeColor.FunktionarPerson // the color of the shape behind the icon
  },
  PhoneNumber: {
    code: "\uf095", // Unicode for phone
    size: 20,
    color: colorMap.iconColor.PhoneNumber, // the color of the icon
    description: "Phone number",
    shapeColor: colorMap.shapeColor.PhoneNumber // the color of the shape behind the icon
  },
  Address: {
    code: "\uf041", // Unicode for user
    size: 20,
    color: colorMap.iconColor.Address, // the color of the icon
    description: "Address node",
    shapeColor: colorMap.shapeColor.Address // the color of the shape behind the icon
  },
  CarRegNumber: {
    code: "\uf1b9", // Unicode for car
    size: 20,
    color: common.white, // the color of the icon
    description: "Car registration number",
    shapeColor: "#7f8c8d" // the color of the shape behind the icon
  },
  CaseNumber: {
    code: "\uf02d", // Unicode for book
    size: 20,
    color: common.white, // the color of the icon
    description: "Case number",
    shapeColor: "#AF69EE" // the color of the shape behind the icon
  },
  BankAccount: {
    code: "\uf19c", // Unicode for bank
    size: 20,
    color: common.white, // the color of the icon
    description: "Bank account",
    shapeColor: "#f39c12" // the color of the shape behind the icon
  },
  Email: {
    code: "\uf0e0", // Unicode for envelope (email)
    size: 20,
    color: common.white, // the color of the icon
    description: "Email address",
    shapeColor: "#2980b9" // the color of the shape behind the icon
  },
  Company: {
    default: {
      code: "\uf1ad", // Unicode for building
      size: 25,
      color: colorMap.iconColor.Company.default,
      description: "Company without flag",
      shapeColor: colorMap.shapeColor.Company.default,
    },
    withDebt: {
      code: "\ue56a", // Unicode for Sack X Mark
      size: 30,
      color: colorMap.iconColor.Company.withDebt,
      description: "Company with KFM debt",
      shapeColor: colorMap.shapeColor.Company.withDebt,
    },
    withBankrupcy: {
      code: "\uf6b7", // Unicode for book with a skull
      size: 30,
      color: colorMap.iconColor.Company.withBankrupcy,
      description: "Bankruptcy",
      shapeColor: colorMap.shapeColor.Company.withBankrupcy,
    },
    withLikvidation: {
      code: "\uf52a", // Unicode for book with a skull
      size: 30,
      color: colorMap.iconColor.Company.withLikvidation,
      description: "Liquidation",
      shapeColor: colorMap.shapeColor.Company.withLikvidation,
    },
    starting: {
      code: "\uf1ad", // Unicode for location dot
      size: 50,
      color: colorMap.iconColor.Company.starting,
      description: "Starting company",
      shapeColor: colorMap.shapeColor.Company.starting,
    },
    ending: {
      code: "\uf140", // Unicode for location dot
      size: 50,
      color: colorMap.iconColor.Company.ending,
      description: "Ending company",
      shapeColor: colorMap.shapeColor.Company.ending,
    },
    highRiskBoard: {
      code: "\uf500", // Unicode for location dot
      size: 30,
      color: colorMap.iconColor.Company.highRiskBoard,
      description: "Company with high risk board",
      shapeColor: colorMap.shapeColor.Company.highRiskBoard,
    },
    activeRelationship: {
      code: "⎯⎯", // 
      size: 30,
      color: common.white,
      description: "Full line for active relationship",
      shapeColor: colorMap.shapeColor.Company.activeRelationship,
    },
    oldRelationship: {
      code: "\uf141", // Unicode for location dot
      color: common.white,
      description: "Dotted line for historical relationship",
      shapeColor: colorMap.shapeColor.Company.oldRelationship,
    },
    indicatorMoreRelationships: {
      code: "🕸️", // Unicode for relationships
      color: common.white,
      description: "Indicator for more relationships",
      shapeColor: colorMap.shapeColor.Company.indicatorMoreRelationships,
  }
  
}
};

/**
 * Overlay icon configuration for additional node indicators
 */
export const overlayIconMap = {
  nextLayerCompanies: {
    code: "🔔", // Unicode bell emoji (more reliable than Font Awesome)
    size: 12,
    color: '#ff0000', // Red color
    description: "Next layer companies available",
    position: 'top-right' // Position relative to main icon
  }
};



/**
 * Edge color configuration - separate from vis-network options to avoid warnings
 */
export const edgeColors = {
  default: '#bdc3c7', // Silver/Light Grey
  badPath: '#c0392b', // Red
  highlight: '#00d4ff' // Cyan
};

/**
 * Get graph visualization behavior options based on user's cognito groups
 * @param accessToken - The user's access token containing cognito groups
 * @param isDarkMode - Whether dark mode is enabled
 * @returns Configuration object for graph visualization
 */
export function getGraphVizBehaviourOptions(accessToken?: string, isDarkMode: boolean = false) {
  const cognitoGroups = accessToken ? getCognitoGroups(accessToken) : [];
  const hasGraphImprovements = cognitoGroups.includes('GraphImprovements');

  // Colors based on mode
  const textColor = isDarkMode ? '#ecf0f1' : '#000000';
  const edgeColor = isDarkMode ? '#bdc3c7' : '#000000';
  
  // Base configuration (default for regular users)
  const baseConfig = {
    nodes: {
      shape: "dot",
      size: 30,
      font: {
        size: 14,
        color: textColor
      }
    },
    edges: {
      color: edgeColor,
      smooth: {
        enabled: true,
        type: 'curvedCW',
        roundness: 0
      },
      arrows: {
        to: { enabled: false },
        from: { enabled: false }
      },
      font: {
        size: 12,
        color: textColor,
        strokeWidth: 0 // Remove stroke for cleaner look in dark mode
      },
      edgeColors: {
        default: isDarkMode ? '#bdc3c7' : '#000000',
        badPath: '#c0392b',
        highlight: '#00d4ff',
        caseNumber: '#AF69EE'
      }
    },
    interaction: {
      hover: true,
      multiselect: true
    },
    configure: {
      enabled: false
    },
    layout: {
      hierarchical: {
        enabled: false
      }
    },
    physics: {
      enabled: true,
        forceAtlas2Based: {
          gravitationalConstant: -750, // Increased repulsion to account for label space
          centralGravity: 0.020,       // Slightly reduced to allow more spreading
          springLength: 160,           // Increased to provide more space between nodes
          springConstant: 0.40,         // Slightly reduced for smoother movement
          damping: 1.00,              // Higher damping for stable navigation after stabilization
          avoidOverlap: 0.5            // Reduced overlap avoidance to improve performance
        },
      solver: 'forceAtlas2Based',
      timestep: 0.35,
      stabilization: {
        enabled: true,
        iterations: 2000,    // Reduced from 2000 to speed up initial rendering
        updateInterval: 5,  // Increased to reduce UI updates during stabilization
        fit: true           // Ensure the graph fits in view after stabilization
      }
    }
  };

  // If user has GraphImprovements group, override with enhanced settings
  if (hasGraphImprovements) {
    return {
      ...baseConfig,
      nodes: {
        ...baseConfig.nodes,
        font: {
          size: 14,
          face: 'Arial, sans-serif',
          vadjust: 0,
          strokeWidth: 2,
          strokeColor: isDarkMode ? '#000000' : 'white',
          color: textColor
        },
        // Add margin to account for label space
        margin: {
          top: 20,
          right: 30,
          bottom: 20,
          left: 30
        },
        // Ensure nodes don't overlap by setting a minimum distance
        borderWidth: 2,
        borderWidthSelected: 3
      },
      edges: {
        ...baseConfig.edges,
        edgeColors: {
          default: '#bdc3c7',
          badPath: '#c0392b',
          highlight: '#00d4ff',
          caseNumber: '#AF69EE'
        },
        width: 0.1, // Thinner lines for lighter appearance
        shadow: { enabled: true, color: isDarkMode ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.5)', size: 5, x: 2, y: 2 },
        selectionWidth: 3,
        hoverWidth: 2,
        smooth: {
          enabled: true,
          type: 'curvedCW',
          roundness: 0.2 // Slightly curved to avoid overlapping labels
        },
        font: {
          size: 12,
          strokeWidth: 1,
          strokeColor: isDarkMode ? '#000000' : 'white',
          align: 'middle',
          color: textColor
        },
        labelHighlightBold: false
      },
      physics: {
        ...baseConfig.physics,
        forceAtlas2Based: {
          gravitationalConstant: -750, // Increased repulsion to account for label space
          centralGravity: 0.020,       // Slightly reduced to allow more spreading
          springLength: 160,           // Increased to provide more space between nodes
          springConstant: 0.40,         // Slightly reduced for smoother movement
          damping: 1.00,              // Higher damping for stable navigation after stabilization
          avoidOverlap: 0.5            // Reduced overlap avoidance to improve performance
        }
      }
    };
  }

  // Return base configuration for regular users
  return baseConfig;
}

// Keep the original as a legacy export for backward compatibility
export const graphVizBehaviourOptions = getGraphVizBehaviourOptions();